import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchCastCategories, deleteCastCategory } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'categoryId', label: 'ID', minWidth: 50 },
  { id: 'categoryName', label: 'Category Name', minWidth: 170 },
  { id: 'description', label: 'Description', minWidth: 300 },
];

const CastCategoryList = ({ onEdit, searchQuery = '' }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadCategories = async () => {
      setLoading(true);
      try {
        const response = await fetchCastCategories();
        if (cancelled) return;
        setCategories(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching caste categories:', err);
        if (!cancelled) {
          setError('Failed to load caste categories. Please try again later.');
          setCategories([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadCategories();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (category) => {
    try {
      await deleteCastCategory(category.categoryId, {
        previousData: category,
        identifier: category.categoryName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting caste category:', err);
      alert('Failed to delete caste category. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Caste Categories
      </Typography>
      
      <MasterDataTable
        persistKey="castCategory"
        data={categories}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No caste categories found. Add your first caste category!"
      />
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default CastCategoryList; 